import * as Scrivito from "scrivito"
import { defaultPageAttributes } from "scrivito/Objs/shared/defaultAttributes"

export const ProjectsPageObjClass = Scrivito.provideObjClass("ProjectsPage", {
  attributes: {
    ...defaultPageAttributes,
    breadcrumbWidget: ["widgetlist", { only: "BreadcrumbWidget" }],
    data: "datalocator"
  },
  extractTextAttributes: ["body"]
})
export type ProjectsPage = InstanceType<typeof ProjectsPageObjClass>
